(function () {
  var theme = window.ChandraTheme;
  if (!theme) return;
  var strings = theme.config.strings;

  function bindCard(card) {
    if (card.hasAttribute('data-bound')) return;
    card.setAttribute('data-bound', '');
    var sizes = card.querySelectorAll('[data-size]');
    var sizeLabel = card.querySelector('[data-size-label]');
    var priceLabel = card.querySelector('[data-price-label]');
    var add = card.querySelector('[data-add]');
    var addLabel = card.querySelector('[data-add-label]');
    var stepper = card.querySelector('[data-stepper]');
    var sizeRing = card.querySelector('[data-size-ring]');
    function moveSizeRing() {
      var on = card.querySelector('[data-size].is-on');
      if (!sizeRing || !on) return;
      sizeRing.style.transform = 'translate(' + on.offsetLeft + 'px,' + on.offsetTop + 'px)';
      sizeRing.style.width = on.offsetWidth + 'px';
      sizeRing.style.height = on.offsetHeight + 'px';
    }
    if (sizeRing) {
      sizeRing.style.transition = 'none';
      moveSizeRing();
      setTimeout(function () { sizeRing.style.transition = ''; }, 50);
      window.addEventListener('resize', moveSizeRing);
    }
    var countLabel = card.querySelector('[data-count-label]');
    if (!add) return;

    function variantId() { return add.getAttribute('data-variant'); }

    var morphTimer = null;
    function sync() {
      if (!stepper) return;
      var qty = theme.cartQty(variantId());
      countLabel.textContent = qty;
      if (qty > 0 && !add.hidden && add.classList.contains('is-done')) {
        if (morphTimer) return;
        morphTimer = setTimeout(function () {
          morphTimer = null;
          stepper.hidden = false;
          add.hidden = true;
          theme.btnState(add, '');
        }, 650);
        return;
      }
      if (morphTimer) return;
      stepper.hidden = qty === 0;
      add.hidden = qty > 0;
    }

    var media = card.querySelector('[data-card-media]');
    var swapToken = 0;
    function swapImage(btn) {
      var id = btn.getAttribute('data-image-id');
      if (!media || !id) return;
      var cur = media.querySelector('.product-card__img--main:not(.is-out)');
      if (!cur || cur.getAttribute('data-src') === id) return;
      card.classList.add('is-switched');
      media.classList.add('is-loading');
      var token = ++swapToken;
      var img = new Image();
      img.className = 'product-card__img product-card__img--main is-in';
      img.alt = btn.getAttribute('data-image-alt') || cur.alt;
      img.setAttribute('data-card-img', 'main');
      img.setAttribute('data-src', id);
      img.sizes = cur.sizes || '(max-width: 600px) 42vw, 236px';
      img.srcset = btn.getAttribute('data-srcset') || '';
      img.src = btn.getAttribute('data-image');
      function go() {
        if (token !== swapToken) return;
        media.classList.remove('is-loading');
        media.insertBefore(img, cur.nextSibling);
        cur.classList.add('is-out');
        setTimeout(function () { img.classList.remove('is-in'); }, 30);
        setTimeout(function () { if (cur.parentNode) cur.parentNode.removeChild(cur); }, 500);
      }
      if (img.decode) img.decode().then(go, go); else { img.onload = go; img.onerror = go; }
    }
    card.addEventListener('mouseleave', function () { card.classList.remove('is-switched'); });

    theme.each(sizes, function (btn) {
      btn.addEventListener('click', function () {
        swapImage(btn);
        theme.each(sizes, function (o) { o.classList.remove('is-on'); o.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-on');
        btn.setAttribute('aria-pressed', 'true');
        moveSizeRing();
        if (sizeLabel) sizeLabel.textContent = btn.getAttribute('data-title') + ' ' + strings.pack;
        if (priceLabel) priceLabel.textContent = btn.getAttribute('data-price');
        var available = btn.getAttribute('data-available') === 'true';
        var url = btn.getAttribute('data-url');
        if (url) theme.each(card.querySelectorAll('[data-card-media], .product-card__title a'), function (a) { a.setAttribute('href', url); });
        if (url && media) {
          var alt = media.querySelector('.product-card__img--alt');
          var hover = btn.getAttribute('data-hover');
          if (hover) {
            if (!alt) { alt = document.createElement('img'); alt.className = 'product-card__img product-card__img--alt'; alt.alt = ''; alt.loading = 'lazy'; alt.sizes = '(max-width: 600px) 42vw, 236px'; media.insertBefore(alt, media.firstChild); }
            alt.srcset = btn.getAttribute('data-hover-srcset') || '';
            alt.src = hover;
          } else if (alt) {
            alt.parentNode.removeChild(alt);
          }
        }
        add.setAttribute('data-variant', btn.getAttribute('data-variant'));
        add.disabled = !available;
        addLabel.textContent = available ? strings.add : strings.soldOut;
        sync();
      });
    });

    add.addEventListener('click', function () {
      if (add.classList.contains('is-loading') || add.classList.contains('is-done') || add.disabled) return;
      theme.btnState(add, 'is-loading');
      theme.addToCart({ items: [{ id: Number(variantId()), quantity: 1 }] }).then(function (res) {
        if (res && res.status) { theme.btnState(add, ''); addLabel.textContent = res.description || res.message; return; }
        theme.btnState(add, 'is-done');
        theme.loadCart(true);
      }).catch(function () { theme.btnState(add, ''); });
    });

    if (stepper) {
      theme.each(stepper.querySelectorAll('[data-step]'), function (btn) {
        btn.addEventListener('click', function () {
          if (stepper.classList.contains('is-busy')) return;
          var next = theme.cartQty(variantId()) + Number(btn.getAttribute('data-step'));
          if (next < 0) return;
          stepper.classList.add('is-busy');
          theme.changeCart(variantId(), next).then(function () { stepper.classList.remove('is-busy'); }).catch(function () { stepper.classList.remove('is-busy'); });
        });
      });
      document.addEventListener('chandra:cart', sync);
    }
  }

  theme.bindCards = function (scope) { theme.each((scope || document).querySelectorAll('[data-product-card]'), bindCard); };
  theme.bindCards(document);
  theme.loadCart();
})();
